import React, { memo } from 'react';
import {
  Input as AntInput,
  InputProps,
  Typography,
  Flex,
} from 'antd';
import { createUseStyles } from 'react-jss';

export interface InputComponentProps extends InputProps {
  placeholder?: any;
}

const useStyle = createUseStyles({});

const { Text } = Typography;

const Input = memo<InputComponentProps>(
  ({ placeholder, ...rest }) => {
    const classes = useStyle();
    return (
      <Flex vertical style={{ flex: 1 }}>
        <Text>{placeholder}:</Text>
        <AntInput
          {...{ placeholder }}
          style={{
            margin: '8px 0px',
            minHeight: 25,
            maxWidth: 100,
          }}
          {...rest}
        />
      </Flex>
    );
  }
);

export { Input };
